import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FormGroupProps } from './types';
import ReadOnlyField from '@/components/common/ReadOnlyField/ReadOnlyField';
import { getMerchDefaultDisplayName } from '@/components/common/ProductUtilities';
import _ from 'lodash';

type Props = FormGroupProps & {
  handleMerchandiseMetadata: (field: string, value: any) => void;
};

export default function MerchandiseDisplayNameFormGroup({
  album,
  readonly,
  disabled,
  handleMerchandiseMetadata,
}: Props) {
  const { t } = useTranslation();

  const defaultDisplayName = useMemo(() => {
    return getMerchDefaultDisplayName(album);
  }, [album]);

  const hasOverride = !_.isNil(album?.merchandiseMetadata?.displayNameOverride);

  const value =
    album?.merchandiseMetadata?.displayNameOverride ?? defaultDisplayName;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    if (newValue === defaultDisplayName) {
      handleMerchandiseMetadata('displayNameOverride', undefined);
    } else {
      handleMerchandiseMetadata('displayNameOverride', newValue);
    }
  };

  return (
    <>
      {!readonly ? (
        <div className="form-group">
          <label
            htmlFor="merchandiseDisplayName"
            className="col-sm-3 form-label"
          >
            {t('product.editProduct.displayName')}
          </label>
          <div className="col-sm-8 product-artist">
            <div className="list-builder">
              <div className="col-sm-9 list-item">
                <div className="list-input">
                  <input
                    id="merchandiseDisplayName"
                    type="text"
                    className="form-control"
                    value={value ?? ''}
                    onChange={handleChange}
                    disabled={disabled}
                  />
                </div>
                {!disabled && hasOverride && (
                  <button
                    className="icon-btn"
                    onClick={() =>
                      handleMerchandiseMetadata(
                        'displayNameOverride',
                        undefined
                      )
                    }
                    type="button"
                  >
                    <i className="icon fas fa-times" aria-hidden="true"></i>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ReadOnlyField
          id={'merchandiseDisplayName'}
          labelTitle={t('product.editProduct.displayName')}
          value={value}
        ></ReadOnlyField>
      )}
    </>
  );
}
